import React from 'react';
import { IconShieldCheck } from './HomeRedesignIcons';
import { useHomeRedesignStrings } from './useHomeRedesignStrings';

const HomeRedesignPromise: React.FC = () => {
  const p = useHomeRedesignStrings().promise;

  return (
    <section className="container-chisme py-10 lg:py-16">
      <div className="relative overflow-hidden rounded-[36px] bg-[#2a0f2a] px-6 py-12 sm:px-10 sm:py-14 lg:px-16 lg:py-[72px]">
        <div
          className="pointer-events-none absolute -right-24 -top-32 size-[460px] rounded-full opacity-90"
          style={{
            background:
              'radial-gradient(circle at center, rgba(235,66,178,0.55) 0%, rgba(235,66,178,0) 70%)',
          }}
          aria-hidden
        />

        <div className="relative flex flex-col gap-8 lg:gap-10">
          <div className="flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between">
            <div>
              <p className="font-jetbrains text-[11px] uppercase tracking-[0.22em] text-[#ffb7e1]">{p.kicker}</p>
              <h2 className="mt-3 font-instrument text-4xl leading-[1.05] text-white sm:text-5xl lg:text-[80px] lg:leading-[0.95] lg:tracking-[-0.025em]">
                <span className="block">{p.h2a}</span>
                <span className="block italic text-[#ff99d5]">{p.h2b}</span>
              </h2>
            </div>
            <div className="flex w-fit items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-2.5">
              <IconShieldCheck className="size-4 shrink-0 text-white" aria-hidden />
              <span className="font-jakarta text-[13px] font-semibold text-white">{p.trustPill}</span>
            </div>
          </div>

          <div className="grid border-t border-white/20 sm:grid-cols-2 lg:grid-cols-4">
            {p.pillars.map((pillar, i) => (
              <div
                key={pillar.title}
                className={`border-b border-white/15 px-1 py-7 sm:px-3 lg:px-6 ${
                  i % 2 === 0 ? 'sm:border-e sm:border-white/15' : ''
                } ${i < 3 ? 'lg:border-e lg:border-white/15' : ''}`}
              >
                <h3 className="mb-2 font-instrument text-2xl italic tracking-[-0.01em] text-white lg:text-[32px]">
                  {pillar.title}
                </h3>
                <p className="font-jakarta text-[14.5px] leading-relaxed text-white/70">{pillar.body}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeRedesignPromise;
